angular.module('routes.export.ExportPayloadResolver', [
  'stack'
])

/**
 * The ExportPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class ExportPayloadResolver
 * @constructor
 * @module routes.export.ExportPayloadResolver
 */
.factory('ExportPayloadResolver', [
  'GLOBAL',
  'ModelsService',
  function (GLOBAL, ModelsService) {
    'use strict';

    return function () {
      return ModelsService.initialize('cases', GLOBAL.apiPath + '/cases');
    };
  }
]);
